
 

 

 

 
class GroupUpdateRequest 
{
    
        Code: string;
    
        userUID: string;
    
        Name: string;
    
        IsActive: boolean;
    
}
 
export default GroupUpdateRequest;
 




